import axiosInstance from "../../apiAxios/axiosInstance";

export const BrandList = async (payload) => {
  const response = await axiosInstance.post("/admin/brand-list", payload);
  return response.data;
};
export const ActiveBrandList = async(payload) => {
   const resposne=await axiosInstance.post("/admin/active-brand-list",payload);
   return resposne.data
};
export const AddBrand = async (payload) => {
  const response = await axiosInstance.post("/admin/brand-store", payload);
  return response.data;
};

export const ViewBrand = async (payload) => {
  const response = await axiosInstance.post("/admin/brand-show", payload);
  return response.data;
};

export const UpdateBrand = async (payload) => {
  const response = await axiosInstance.post("/admin/brand-update", payload);
  return response.data;
};

export const DeleteBrand = async (payload) => {
  const response = await axiosInstance.post("/admin/brand-delete", payload);
  return response.data;
};

export const BrandChangeStatus = async (payload) => {
  const response = await axiosInstance.post(
    "/admin/brand-status-update",
    payload
  );
  return response.data;
};